import { render, staticRenderFns } from "./change-order.vue?vue&type=template&id=ed312ee0&"
import script from "./change-order.vue?vue&type=script&lang=js&"
export * from "./change-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports